import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Hub Manager Dashboard Components
import HubManagerIndex from './views/MainBranch/containers/HubManagerIndex'
import HubManagerDashBoard from './views/MainBranch/containers/HubManagerDashBoard'
import Hub_DeliveriesList from './views/MainBranch/containers/Hub_DeliveriesListView'
import Hub_OnlineAgentsList from './views/MainBranch/containers/Hub_OnlineAgentsListView'
import Hub_AgentActivityMap from './views/MainBranch/containers/Hub_AgentActivityMap'
import GraphsComponentHub from './views/MainBranch/containers/GraphsComponentHub'

// Hub-specific agent and facility components
import Hub_AgentsList from './views/MainBranch/containers/Hub_AgentsListView'
import Hub_HealthCenterList from './views/MainBranch/containers/Hub_HealthCenterListView'

// Shared components that hub managers might need
import DeliveryAgentDetails from './views/MainBranch/containers/DeliveryAgentDetails'
import HealthCenterDetails from './views/MainBranch/containers/HealthCenterDetails'

const HubBaseRouter = () => {
  console.log('🔍 HubBaseRouter: Rendering hub routes');
  return (
  <Switch>
    {/* Hub Manager Index (Root) */}
    <Route exact path='/' component={HubManagerIndex} />
    <Route exact path='/hub_dashboard/' component={HubManagerIndex} />
    <Route exact path='/hub_dashboard_old/' component={HubManagerDashBoard} />
    
    {/* Hub Operations */}
    <Route exact path='/hub_deliveries/' component={Hub_DeliveriesList} />
    <Route exact path='/hub_online_agents/' component={Hub_OnlineAgentsList} />
    
    {/* Hub Reports & Analytics */}
    <Route exact path='/hub_agent_activity_map/' component={Hub_AgentActivityMap} />
    <Route exact path='/hub_analytics_graphs/' component={GraphsComponentHub} />
    
    {/* Hub Agents & Facilities Management */}
    <Route exact path='/hub_deliveryagents/' component={Hub_AgentsList} />
    <Route exact path='/hub_healthcenters/' component={Hub_HealthCenterList} />
    
    {/* Details Views */}
    <Route exact path='/hub_agent_details/:id' component={DeliveryAgentDetails} />
    <Route exact path='/hub_healthcenter_details/:id' component={HealthCenterDetails} />
    
    {/* Default fallback */}
    <Route path='/' component={HubManagerIndex} />
  </Switch>
  );
};

export default HubBaseRouter;
